
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ways-to-stay/[[...page]]",
      function () {
        return require("private-next-pages/ways-to-stay/[[...page]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ways-to-stay/[[...page]]"])
      });
    }
  